const SIDEBAR_STATE_KEY = 'sidebar-open';

// Mobile breakpoint (matches MUI Joy 'sm' breakpoint)
const MOBILE_BREAKPOINT = 600;

export function isMobile() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < MOBILE_BREAKPOINT;
    }
    return false;
}

export function openSidebar() {
    if (typeof window !== 'undefined') {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.setProperty('--SideNavigation-slideIn', '1');
        // Only save to localStorage on desktop
        if (!isMobile()) {
            localStorage.setItem(SIDEBAR_STATE_KEY, 'true');
        }
    }
}

export function closeSidebar() {
    if (typeof window !== 'undefined') {
        document.documentElement.style.removeProperty('--SideNavigation-slideIn');
        document.body.style.removeProperty('overflow');
        // Only save to localStorage on desktop
        if (!isMobile()) {
            localStorage.setItem(SIDEBAR_STATE_KEY, 'false');
        }
    }
}

export function toggleSidebar() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        const slideIn = window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--SideNavigation-slideIn');
        if (slideIn) {
            closeSidebar();
        } else {
            openSidebar();
        }
    }
}